import ClassicExtension from "./ClassicExtension";

/**
 * Make any button hypertext link - cos a and button element can't hold div element inside
 * Add `data-href="/new/location"` to your button
 *
 * @example
 *  ```HTML
 *  <button data-href="/new/location" class="btn unbutton">
 *      <div class="card">
 *          ...
 *      </div>
 *  </button>
 *  ```
 */
export default class ButtonAsLinkExtension extends ClassicExtension {
    protected init($root: JQuery): void {
        $root.find('[data-href]').each((i, el) => {
            const $button = $(el);
            $button.on('click', (e) => {
                e.preventDefault();
                const href = $button.data('href');
                if (href) {
                    window.location.href = href;
                }
            });
        });
    }
}